import { useMemo } from 'react';
import { Typography, Card, Badge, Spin } from 'antd';
import { RiseOutlined } from '@ant-design/icons';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  Bar,
  Legend
} from 'recharts';
import './top-clients.css';

const { Title, Text } = Typography;

const TopClients = ({
  data,
  dataMXN,
  dataUSD,
  loading,
  limit = 5,
  title = "Top 5 Clientes",
  currentDateInfo
}) => {


  const clients = useMemo(() => {

    const mxn = dataMXN?.top_clients || [];
    const usd = dataUSD?.top_clients || [];

    const map = {};

    mxn.forEach(client => {
      map[client.client_id] = {
        client_id: client.client_id,
        name: client.name,
        bussiness: (client.bussiness || '').toUpperCase(),
        mxn: client.total_sales || 0,
        usd: 0
      };
    });

    usd.forEach(client => {
      if (!map[client.client_id]) {
        map[client.client_id] = {
          client_id: client.client_id,
          name: client.name,
          bussiness: (client.bussiness || '').toUpperCase(),
          mxn: 0,
          usd: client.total_sales || 0
        };
      } else {
        map[client.client_id].usd = client.total_sales || 0;
      }
    });

    return Object.values(map).slice(0, limit);
  }, [data, limit]);

  return (
    <Card className="dashboard-card">
      <div className="card-header">
        <div className="card-icon card-icon-orange">
          <RiseOutlined />
        </div>
        <div>
          <Title level={4}>{title}</Title>
          <Text type="secondary">{currentDateInfo}</Text>
        </div>
      </div>

      <div className="card-content">
        {loading ? (
          <Spin />
        ) : clients.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>


            <div style={{ height: 220 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={clients}
                  layout="vertical"
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />

                  <XAxis
                    type="number"
                    tickFormatter={(value) =>
                      `$${value.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}`
                    }
                  />

                  <YAxis
                    type="category"
                    dataKey="bussiness"
                    width={100}
                    tick={{ fontSize: 12 }}
                  
                  />

                  <RechartsTooltip
                    formatter={(value, name) => [
                      `$${parseFloat(value).toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}`,
                      name === 'MXN' ? 'MXN' : 'USD'
                    ]}
                  />

                  <Legend />

                  <Bar
                    dataKey="mxn"
                    fill="#1890ff"
                    name="MXN"
                    radius={[0, 4, 4, 0]}
                  />

                  <Bar
                    dataKey="usd"
                    fill="#52c41a"
                    name="USD"
                    radius={[0, 4, 4, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>


            <div className="top-clients-list">
              {clients.map((client, index) => (
                <div key={client.client_id || index} className="client-item">

                  <div className="client-rank">
                    <Badge
                      count={index + 1}
                      style={{
                        backgroundColor: index < 3 ? '#1890ff' : '#8c8c8c'
                      }}
                    />
                  </div>

                  <div className="client-info">
                    <Text strong style={{ fontSize: '14px', textTransform: 'uppercase' }}>
                      {client.bussiness || 'Cliente'}
                    </Text>
                    <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                      {client.name || ''}
                    </Text>
                  </div>

                  <div className="client-value">
                    <Text strong style={{ color: '#1890ff', display: 'block' }}>
                      MXN: ${client.mxn.toLocaleString('es-MX', {
                        minimumFractionDigits: 2
                      })}
                    </Text>
                    <Text strong style={{ color: '#52c41a' }}>
                      USD: ${client.usd.toLocaleString('es-MX', {
                        minimumFractionDigits: 2
                      })}
                    </Text>
                  </div>

                </div>
              ))}
            </div>

          </div>
        ) : (
          <Text type="secondary">
            No hay datos de clientes para este período
          </Text>
        )}
      </div>
    </Card>
  );
};

export default TopClients;